
// 
// Convert the time format of time:7.18333333 (hours)
// to minutes passed in the day 
//

function convertTimeToMinutes(data) {
    return data.map(subArray => {
        if (!subArray.length) return []; 
        
        let seenMinutes = new Set();
        
        return subArray.map(item => {
            let minutes = Math.floor(item.time * 60); 
            
            if (seenMinutes.has(minutes)) return null; 
            seenMinutes.add(minutes);
            
            return { time: minutes, value: item.value };
        }).filter(item => item !== null); 
    });
}

// 
// Ensure that the datasets all start at 12:00 AM, and fill in large missing gaps 
// with {time: time, value: '0.000'} to minimize breaks in data
//

export const fillMissingMinutes = (dataArrays) => {

    // First convert each charger's data into time: minutes for easier looping
    let convertedToMinutes = convertTimeToMinutes(dataArrays);

    return convertedToMinutes.map(subArray => {
        if (!subArray.length) return []; // Skip empty sub-arrays
        
        let filledArray = [];
        let existingTimes = new Set(subArray.map(item => item.time));
        let minTime = Math.min(...existingTimes);
        let maxTime = Math.max(...existingTimes);
        
        // Fill missing values from 0 to minTime - 1
        for (let t = 0; t < minTime; t++) {
            filledArray.push({ time: t, value: '0.000' });
        }
        
        // Fill in gaps within the array if the gap is larger than 5 minutes
        for (let i = 0; i < subArray.length - 1; i++) {
            let current = subArray[i];
            let next = subArray[i + 1];
            filledArray.push(current);
            
            if (next.time - current.time > 10) {
                for (let t = current.time + 1; t < next.time; t++) {
                    filledArray.push({ time: t, value: '0.000' });
                }
            }
        }
        
        // Add the last element
        filledArray.push(subArray[subArray.length - 1]);
        
        return filledArray;
    });
};

    // 
    // This is for the cumulative energy consumption graph, 
    // and does the same as above, but ignores gaps 
    // 

export const fillMissingMinutesWithoutGaps = (dataArrays) => {

    // First convert each charger's data into time: minutes for easier looping
    let convertedToMinutes = convertTimeToMinutes(dataArrays)

    return convertedToMinutes.map(subArray => {
        if (!subArray.length) return []; // Skip empty sub-arrays
        
        let filledArray = [];
        let existingTimes = new Set(subArray.map(item => item.time));
        let minTime = Math.min(...existingTimes);
        
        // Fill missing values from 0 to minTime - 1
        for (let t = 0; t < minTime; t++) {
            filledArray.push({ time: t, value: '0.000' });
        }
        
        // Add existing values
        filledArray.push(...subArray);
        
        return filledArray;
    });
}

